import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TExchangeRatesApi } from './types';

export const exchangeRates: TExchangeRatesApi = {
	getDailyExchangeRateList: (payload) =>
		http.post(endpoint.exchangeRates.DAILY_LIST, payload).then((response) => response.data),
	refreshDailyExchangeRates: () =>
		http.post(endpoint.exchangeRates.DAILY_REFRESH).then((response) => response.data),

	getAnnualExchangeRateList: (payload) =>
		http.post(endpoint.exchangeRates.ANNUAL_LIST, payload).then((response) => response.data),

	getGbpMonthlyExchangeRateList: (payload) =>
		http.post(endpoint.exchangeRates.GBP_MONTHLY_LIST, payload).then((response) => response.data),

	getEuMonthlyExchangeRateList: (payload) =>
		http.post(endpoint.exchangeRates.EU_MONTHLY_LIST, payload).then((response) => response.data),

	getNonEuExchangeRateList: (payload) =>
		http.post(endpoint.exchangeRates.NON_EU_LIST, payload).then((response) => response.data),
};
